"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var UndoSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M6.85355339,7.14644661 C7.02711974,7.32001296 7.04640489,7.58943736 6.91140884,7.7843055 L6.85355339,7.85355339 C6.67998704,8.02711974 6.41056264,8.04640489 6.2156945,7.91140884 L6.14644661,7.85355339 L3.79289322,5.5 L6.14644661,3.14644661 C6.34170876,2.95118446 6.65829124,2.95118446 6.85355339,3.14644661 C7.02711974,3.32001296 7.04640489,3.58943736 6.91140884,3.7843055 L6.85355339,3.85355339 L5.70589322,5 L10.5,5 C12.9852814,5 15,7.01471863 15,9.5 C15,11.9142733 13.0987635,13.8844891 10.7118357,13.995102 L10.5,14 L8,14 L8,13 L10.5,13 C12.4329966,13 14,11.4329966 14,9.5 C14,7.6314366 12.5357224,6.10487355 10.6920352,6.00517886 L10.5,6 L5.70789322,6 L6.85355339,7.14644661 Z" })));
};
UndoSmall.displayName = 'UndoSmall';
exports.default = UndoSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=UndoSmall.js.map